import React from 'react';
import { labels } from '../../../../../../util/utils';
import Modal from '../../../../../Common/Modal/Modal';
import styled from 'styled-components';

function ReImportConfirmationModal(props) {

    const clickOnCancel = () => {
		props.setShowConfirmationModal(false);
		props.setIsDisableImportOption(false);
    };

    const clickOnConfirm = () => {
		props.setShowConfirmationModal(false);
		props.CanfirmationCallback();
    };

    return (
        <>
            <Modal
                show={props.showConfirmationModal}
                title={labels.reImportConfirmationTitle}
                modalContainerClass="reimport-modal"
                closeBtnTitle={labels.cancelLabel}
                closeTitle={labels.cancelLabel}
                confirmBtnTitle={labels.confirmLabel}
                modalsize={'small'}
                onHide={clickOnCancel}
                onOkClick={clickOnConfirm}
                showButtons
                isAresView
            >
                <StyledReImportModalBody>
					<span className="import-msg">{labels.reImportConfirmationMessagePart1}</span>
					<span className="import-msg">{labels.reImportConfirmationMessagePart2}</span>
                </StyledReImportModalBody>
            </Modal>
        </>
    );
}
export default ReImportConfirmationModal;

const StyledReImportModalBody = styled.section`
	padding:var(--px-30) var(--px-20) var(--px-10) var(--px-20);
	.import-msg {
		display:block;
		font-size: var(--px-14);
		font-weight: normal;
		 margin-bottom: var(--px-20);
	}
`;
